



































































import {Component, Mixins} from 'vue-property-decorator';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import DefaultFormMixin from '@/views/DefaultFormMixin';
import SelectInput from '@/components/input/SelectInput.vue';
import CommonValidators from '@/validator/CommonValidators';
import {
  CodeRetrieveResponse, CodesRetrieveResponse, CommonModelUtils, ReceiverRetrieveResponse,
  SenderReceiverPickDialogRequest
} from '@/model/CommonModel';
import CommonApi from '@/api/CommonApi';
import CaseApi from '@/api/CaseApi';
import ApiUtils from '@/utils/ApiUtils';
import MessageUtils from '@/utils/MessageUtils';
import {CIOMS, XML} from '@/utils/Constants.ts';
import BooleanCheckboxInput from '@/components/input/BooleanCheckboxInput.vue';
import AdminApi from '@/api/AdminApi';

@Component({
             components: {
               BooleanCheckboxInput,
               CommonPromptDialog, CommonButton, SelectInput
             },
             mixins: [DialogEventsMixin, DefaultFormMixin]
           })
export default class CaseReportDownloadDialog extends Mixins(DialogEventsMixin, DefaultFormMixin) {
  private visible: boolean = false;
  private selectedReport: any = [];
  private senders: CodeRetrieveResponse[] = [];
  private receivers: ReceiverRetrieveResponse[] = [];
  private ciomsOrientations: CodeRetrieveResponse[] = [];
  private ciomsDataOrderings: CodeRetrieveResponse[] = [];
  private receiverType: string = '';

  private form: any = {
    data: {
      senderKey: '',
      receiverName: '',
      ciomsOrientation: '',
      ciomsDataOrdering: '',
      notation: '',
    },
    rules: {
      senderKey: {
        validator: CommonValidators.required(this), trigger: 'change'
      },
      receiverName: {
        validator: CommonValidators.required(this), trigger: 'change'
      }
    }
  };

  get isVisible() {
    return this.visible;
  }

  get isReceiverDisable() {
    return this.$store.getters.isCroType && this.reportTypeIsXML && this.form.data.senderKey === '';
  }

  get reportTypeIsXML() {
    return this.visible && this.selectedReport.reportList.reportFormat === XML;
  }

  get reportTypeIsCIOMS() {
    return this.visible && this.selectedReport.reportList.reportId.includes(CIOMS);
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('caseReportDownloadDialog', (params: SenderReceiverPickDialogRequest) => {
          this.selectedReport = params;
          return Promise.all([this.show(params), this.retrieveNotation()]).finally(() => {
            this.loading = false;
            this.componentInitialized = true;
          });
        });

    this.$modal.getEventBus().$on('hideCaseReportDownloadDialog', () => this.onCancel());
  }

  public show(params: SenderReceiverPickDialogRequest): Promise<any> {
    this.visible = true;

    if (this.$store.getters.isCroType && this.reportTypeIsXML) {
      return CommonApi.retrieveCodes('SENDER_LIST')
                      .then((res: CodesRetrieveResponse) => {
                        this.senders = CommonModelUtils.getOrDefault(res.data, {codeList: []}).codeList;
                      });
    } else {
      const caseKey = this.$route.params.caseKey;

      return Promise.all([
        CaseApi.retrieveCaseReportEmailAndDownloadReceivers(this.$route.params.sponsorKey, {caseKey}),
        this.retrieveCiomsOptions()
      ]).then(([value]) => {
        this.receivers = CommonModelUtils.getOrDefault(value.data, {receiverList: []}).receiverList;
      });
    }
  }

  private onChangeSender(senderKey: string) {
    this.receivers = [];
    this.form.data.receiverName = '';
    this.receiverType = '';

    if (senderKey === '' || senderKey === undefined) {
      return;
    }

    const caseKey = this.$route.params.caseKey;
    return CaseApi.retrieveCaseReportEmailAndDownloadReceivers(this.$route.params.sponsorKey, {caseKey, senderKey})
                  .then((res: ReceiverRetrieveResponse) => {
                    this.receivers = CommonModelUtils.getOrDefault(res.data, {receiverList: []}).receiverList;
                  });
  }

  public onChangeReceiver(receiverName: string) {
    if (receiverName === '' || receiverName === undefined) {
      this.receiverType = '';
      return;
    }
    const selectedReceiver = this.receivers.find((item: any) => item.receiverName === receiverName);
    this.receiverType = CommonModelUtils.getOrDefault(selectedReceiver, {receiverType: ''}).receiverType;
  }

  private onCancel() {
    this.visible = false;
  }

  public onDownload() {
    this.validation(() => this.download());
  }

  private download() {
    MessageUtils.clear();

    this.loading = true;
    this.getDownloadPromise()
        .then(ApiUtils.fileDownloadHandler, ApiUtils.rejectedHandler)
        .catch((errMsg: string) => this.afterRequestFail(errMsg))
        .finally(() => {
          this.loading = false;
          this.visible = false;
        });
  }

  protected getDownloadPromise(): Promise<any> {
    MessageUtils.clear();
    const report = this.selectedReport.reportList;
    const sender = this.form.data.senderKey;
    const receiverType = this.receiverType;
    const receiverName = this.form.data.receiverName;
    const unblindedValueApplicable = this.$store.getters.unblind;
    const notation = this.form.data.notation;
    const ciomsOrientation = this.form.data.ciomsOrientation;
    const ciomsDataOrdering = this.form.data.ciomsDataOrdering;

    return CaseApi.downloadReport(this.$route.params.caseKey, report.reportId,
                                  {sender, receiverType, receiverName, unblindedValueApplicable,
                                    notation, ciomsOrientation, ciomsDataOrdering, test: 'test'});
  }

  public retrieveNotation() {
    return AdminApi.retrieveNotation(this.$route.params.sponsorKey)
                   .then((res: any) => {
                     this.form.data.notation = res.data.notation;
                   });
  }

  public retrieveCiomsOptions() {
    const sponsorKey = this.$route.params.sponsorKey;

    return this.reportTypeIsCIOMS ? Promise.all([
          CommonApi.retrieveCodes('CIOMS_ORIENTATION'),
          CommonApi.retrieveCodes('CIOMS_DATA_ORDERING'),
          AdminApi.retrieveCiomsOrientation(sponsorKey),
          AdminApi.retrieveCiomsDataOrdering(sponsorKey)
        ]).then((values: [CodesRetrieveResponse, CodesRetrieveResponse, any, any]) => {
          this.ciomsOrientations = CommonModelUtils.getOrDefault(values[0].data, {codeList: []}).codeList;
          this.ciomsDataOrderings = CommonModelUtils.getOrDefault(values[1].data, {codeList: []}).codeList;
          this.form.data.ciomsOrientation = values[2].data.ciomsOrientation;
          this.form.data.ciomsDataOrdering = values[3].data.ciomsDataOrdering;
        })
        : Promise.resolve();
  }

  public afterClosed() {
    this.form.data.senderKey = '';
    this.form.data.receiverName = '';
    this.loading = true;
    const $refFrom: any = this.$refs.form;
    if ($refFrom && $refFrom.resetFields instanceof Function) {
      $refFrom.resetFields();
    }
  }

  public destroyed() {
    this.$modal.getEventBus().$off('caseReportDownloadDialog');
    this.$modal.getEventBus().$off('hideCaseReportDownloadDialog');
  }

}
